import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../../assets/css/icons.css';
import '../../assets/css/style.css'
import { SERVER_IP, PORT, ud, jwt, auth_response_flow } from '../../Server'
import axios from 'axios';
import swal from 'sweetalert';
import 'react-dropdown-tree-select/dist/styles.css'


class ChangePassword extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            old_pass: "",
            new_pass: "",
            conf_pass: "",
            errors: {
                old_pass: "",
                new_pass: "",
                conf_pass: "",
            },
        }
    }

    onChangeInput = (e) => {
        e.preventDefault();
        this.setState({ [e.target.name]: e.target.value })
    }

    ChangeEvent = (e) => {
        e.preventDefault();
        Object.keys(this.state.errors).map((list, index) => this.checkRequirement(list, this.state[list]))
        this.checkRequirement(e)
        if (validateForm(this.state.errors)) {
        } else {
            swal("Invalid Input ..!!")
            return
        }
        var data = {
            email: ud.email,
            id: ud.id,
            oldpassword: this.state.old_pass,
            newPassword: this.state.new_pass
        }
        let headers = {
            'user_id': (ud.id).toString(),
            'session_id': (ud.session_id).toString(),
            'user_type': (ud.usertype).toString(),
            'main_id': (ud.main_id).toString(),
            'jwt_token': (jwt),
            'c_id': (ud.c_id).toString()
        }
        let _this = this;
        axios.post(`${SERVER_IP}/usersForgotPassword/passwordChange`, data, { withCredentials: true, headers: headers })
            .then(function (response) {
                if (response.status === 200) {
                    if (response.data.error === false) {
                        swal(response.data.message, "", "success")
                        window.location.href = "/dashboard"
                        return
                    } else {
                        auth_response_flow(response.data, (return_response) => {
                            if (return_response.error === false && return_response.retry === true) {
                                _this.ChangeEvent(e);
                            }
                        })
                    }
                }
            })
            .catch(function (error) {
                swal("Something Went Wrong. Please Retry.", "", "warning")
            });
    }
    checkRequirement = (name, value) => {
     
        let errors = this.state.errors;

        switch (name) {
            case 'old_pass':
                errors.old_pass =
                    value.length < 1
                        ? 'Please Add Old Password!'
                        : '';
                break;

            case 'new_pass':
                errors.new_pass =
                    value.length < 4
                        ? 'Password must be 4 characters long!'
                        : '';
                break;

            case 'conf_pass':
                errors.conf_pass =
                    this.state.new_pass !== value || value.length < 4
                        ? 'Password and Confirm Password do not match!'
                        : '';
                break;
            default:
                break;
        }
        this.setState({ errors });
    }


    render() {
        const { errors } = this.state;
        console.log(errors)
        return (
            <div>
                <div class="xp-breadcrumbbar">
                    <div class="row">
                        <div class="col-md-6 col-lg-6">
                            <h4 class="xp-page-title">Change Password</h4>
                        </div>
                        <div class="col-md-12 col-lg-12">
                            <div class="xp-breadcrumb">
                                <ol class="breadcrumb">
                                    <li class="breadcrumb-item"><a onClick={() => window.location.href = "/dashboard"}><i class="icon-home"></i></a></li>
                                    <li class="breadcrumb-item">Change Password</li>
                                </ol>

                            </div>
                        </div>
                    </div>
                </div>
                <div className="xp-contentbar p-30">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="card m-b-30">
                                <div className="card-header bg-primary">
                                    <h5 className="card-title text-white">Change Password</h5>
                                </div>
                                <div className="card-body">
                                    <div className="form-row">
                                        <div className="form-group col-md-12">
                                            <label for="exampleInputEmail1">Old Password</label>
                                            <input type="password" onChange={this.onChangeInput} name="old_pass" className="form-control" placeholder="Enter Old Password" />
                                            {errors.old_pass.length > 0 && <span className='text-danger'>{errors.old_pass}</span>}

                                        </div>

                                    </div>

                                    <div className="form-row">
                                        <div className="form-group col-md-6">
                                            <label for="exampleInputEmail1">New Password</label>
                                            <input type="password" onChange={this.onChangeInput} name="new_pass" className="form-control" placeholder="Enter New Password" />
                                            {errors.new_pass.length > 0 && <span className='text-danger'>{errors.new_pass}</span>}

                                        </div>
                                        <div className="form-group col-md-6">
                                            <label for="exampleInputEmail1">Confirm Password</label>
                                            <input type="password" onChange={this.onChangeInput} name="conf_pass" className="form-control" placeholder="Confirm New Password" />
                                            {errors.conf_pass.length > 0 && <span className='text-danger'>{errors.conf_pass}</span>}

                                        </div>
                                    </div>

                                    <button onClick={this.ChangeEvent} className="btn btn-primary">Change Password</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
export default ChangePassword

const validateForm = (errors) => {
    let valid = true;
    Object.values(errors).forEach(
        (val) => val.length > 0 && (valid = false)
    );
    return valid;
}